import React from 'react'

const SeoInformation = () => {
  return (
    <div>SeoInformation</div>
  )
}

export default SeoInformation